import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import classnames from "classnames";
import { isEmpty } from "lodash";
import { usePagination, DOTS } from "app/hooks/usePagination";
import "./pagination.scss";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize = +process.env.REACT_APP_PAGE_SIZE,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const [lastPage, setLastPage] = useState(0);

  useEffect(() => {
    !isEmpty(paginationRange) &&
      setLastPage(paginationRange[paginationRange.length - 1]);
  }, [paginationRange]);

  useEffect(() => {
    currentPage > 0 && lastPage > 0 && currentPage > lastPage && onPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, lastPage]);

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  return (
    <Card className="w-100">
      <Card.Body className="p-0">
        <div className="d-flex flex-row justify-content-between align-items-center m-3">
          <div className="secondary-text">
            <strong>Total: {totalCount} Registros.</strong>
          </div>
          <div>
            <ul
              className={classnames("pagination-container", {
                [className]: className,
              })}
            >
              <li
                key={0}
                className={classnames("pagination-item", {
                  disabled: currentPage === 1,
                })}
                onClick={onPrevious}
              >
                <div className="arrow left" />
              </li>
              {paginationRange.map((pageNumber, index) => {
                if (pageNumber === DOTS) {
                  return (
                    <li key={index + 1} className="pagination-item dots">
                      &#8230;
                    </li>
                  );
                }

                return (
                  <li
                    key={index + 1}
                    className={classnames("pagination-item", {
                      selected: pageNumber === currentPage,
                    })}
                    onClick={() => onPageChange(pageNumber)}
                  >
                    {pageNumber}
                  </li>
                );
              })}

              <li
                key={paginationRange.length + 1}
                className={classnames("pagination-item", {
                  disabled: currentPage === lastPage,
                })}
                onClick={onNext}
              >
                <div className="arrow right" />
              </li>
            </ul>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Pagination;
